import EditMenuRangesModal from './EditMenuRangesModal';
export default EditMenuRangesModal;
